import { useState, useEffect } from 'react';
import { STALE_THRESHOLD_MS, TICK_FRESHNESS_MS } from '../helper/pollingConfig';

export function useFreshness(lastDataTimestamp: number | null) {
  const [secondsAgo, setSecondsAgo] = useState(0);

  useEffect(() => {
    if (lastDataTimestamp == null) return;

    const tick = () => {
      setSecondsAgo(Math.floor((Date.now() - lastDataTimestamp) / 1000));
    };

    tick();
    const interval = setInterval(tick, TICK_FRESHNESS_MS);
    return () => clearInterval(interval);
  }, [lastDataTimestamp]);

  const isStale = secondsAgo >= STALE_THRESHOLD_MS / 1000;

  return { secondsAgo, isStale };
}
